import ViewPadrao from "../views/ViewPadrao";
import FuncionarioList from "../views/FuncionarioList";
import FuncionarioCad from "../views/FuncionarioCad";

export default {
  path: "funcionario",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "funcionario-list",
      component: FuncionarioList
    },
    {
      path: "novo",
      name: "funcionario-formulario",
      component: FuncionarioCad
    },
    {
      path: "editar/:id",
      name: "funcionario-formulario-editar",
      component: FuncionarioCad
    }
  ]
};
